export const ANP_SET_SIDEBAR = 'ANP_SET_SIDEBAR';
export const ANP_SET_VIEW = 'ANP_SET_VIEW';
export const ANP_SET_FILTERS = 'ANP_SET_FILTERS';
export const ANP_SET_FILTERS_DATA = 'ANP_SET_FILTERS_DATA';
export const ANP_SET_FILTERS_LOADING = 'ANP_SET_FILTERS_LOADING';
export const ANP_SET_GRID = 'ANP_SET_GRID';
export const ANP_SET_DATA = 'ANP_SET_DATA';
export const ANP_SET_ROW = 'ANP_SET_ROW';
export const ANP_SET_LOADING = 'ANP_SET_LOADING';
export const ANP_SET_GRID_LOADING = 'ANP_SET_GRID_LOADING';
export const ANP_SET_GRID_RELOAD_DATA = 'ANP_SET_GRID_RELOAD_DATA';
export const ANP_SET_GRID_DATA = 'ANP_SET_GRID_DATA';
export const ANP_SET_TOTAL_ROWS = 'ANP_SET_TOTAL_ROWS';
export const ANP_SET_LAST_PAGE = 'ANP_SET_LAST_PAGE';
export const ANP_SET_MODAL_DETAILS = 'ANP_SET_MODAL_DETAILS';
export const ANP_SET_ROW_IMAGE = 'ANP_SET_ROW_IMAGE';
